import ListOfCategories from './ListOfCategories';
export default ListOfCategories;